import React from 'react';

let TypeCacaVazamento = props => (
  <svg {...props} fill="none" viewBox="0 0 34.016 34.016">
    <path
      d="M11.7 10h10.5V7.5l-3.3-1.3V4.3c0-1.1-.2-1.3-1.3-1.3h-1.3c-1.1 0-1.3.2-1.3 1.3v1.9l-3.3 1.3V10z"
      fill="#006699"
    />
    <path
      d="M8.4 4.8C7.3 4.8 6.4 5.7 6.4 6.8v21.1c0 1.1.9 2 2 2h17.2c1.1 0 2-.9 2-2V6.8c0-1.1-.9-2-2-2h-5.2l3.3 1.3v5.1H10.3V6.1l3.3-1.3H8.4zm8.6 8.2c.4 0 .8.2 1.1.6 2 2.7 4.9 6.8 4.9 9.9 0 3.3-2.7 6-6 6s-6-2.7-6-6c0-3.1 2.9-7.2 4.9-9.9.3-.4.7-.6 1.1-.6zm0 3.5c-1.8 2.6-3.8 5.7-3.8 7 0 2.1 1.7 3.8 3.8 3.8s3.8-1.7 3.8-3.8c0-1.3-2-4.4-3.8-7z"
      fill="#006699"
    />
  </svg>
);

TypeCacaVazamento = React.memo(TypeCacaVazamento);
TypeCacaVazamento.displayName = 'TypeCacaVazamento';

export default TypeCacaVazamento;
